import { OnboardingPartnerState, OnboardingRootState } from "../reducers/rootReducer";

export const getOnboardingState = (state: OnboardingRootState): OnboardingPartnerState =>
  state["publisher-onboarding"];
